import { Api } from "../config/api";
import { Base64Service } from "./base64.service";
import { CryptoService } from "./crypto.service";
import { SessionService } from "./session.service";
import { Injectable } from "@angular/core";
import { RequestOptions, Http } from "@angular/http";
import { Router } from "@angular/router";
import { Observable } from "rxjs/Rx";
import "rxjs/add/operator/map";
import "rxjs/add/observable/throw";
import { AES, SHA256, PBKDF2 } from "crypto-js";
import { User } from "../../model/shared/user/user";
import * as CryptoJS from "crypto-js";

@Injectable()
export class RequestService {
  public bIsRequesting = false;

  private excludeUrls = [
    Api.Agent.TransactionSender,
    Api.Agent.TransactionRate,
  ];

  private readonly DELAY_TIME = 500;

  public enc_pad = null;

  private readonly PASS_SHA = 10;

  private readonly PASS_SALT =
    "edZiYWwetzgSh^QAebw^CNyEOAG(tIgkGXo@@7VpBFHKOuEBeCpRdFYNE*!@a^yB!vlVJ0o&&4S#I^GaNszuHBi8^qcXThWBL%5*iq_*lvoBsW^vWUC$0)CnltZw#CzQv+aoWH0+kd*Uc%w^js8qSt7JLRcPq&K#xl_iNP$GBP9Yg!Qw&11TDE42W$xa%JzB%+XRPRPb!+xN*k(j)$8#M_F!in&VBYfWxi(g%N8+yD+wvJoT4!loY0KXdX$NXsZ9";

  constructor(
    private http: Http,
    private sessionService: SessionService,
    public base64Service: Base64Service,
    private cryptoService: CryptoService,
    private router: Router
  ) {}

  public _raw(): Http {
    return this.http;
  }

  public requestStatus(): boolean {
    return this.bIsRequesting;
  }

  private makePassphrase(): string {
    if (!this.enc_pad) {
      this.enc_pad = this.sessionService.SessionCryptKey;
    }

    let tempphrase = this.enc_pad;

    for (let i = 0; i < this.PASS_SHA; i++) {
      tempphrase = SHA256(tempphrase.toString() + this.PASS_SALT);
    }
    return tempphrase.toString();
  }

  public requestEncrypt(data: any): string {
    let enc: any = this.base64Service.encode(data);
    if (this.enc_pad || this.sessionService.SessionCryptKey) {
      enc = AES.encrypt(enc, this.makePassphrase());
      enc = btoa(atob(enc.toString()).replace("Salted__", ""));
    }
    return enc;
  }

  public coiDecrypt(data: any): string {
    const temp_enc_pad = this.enc_pad;
    this.enc_pad = "COI-ENC-KEY";
    const enc = this.base64Service.decode(
      this.cryptoService.aesDecrypt(data, this.makePassphrase())
    );
    this.enc_pad = temp_enc_pad;
    return enc;
  }

  public userRequestEncrypt(user: User) {
    if (user.password && user.password !== "") {
      user.password = this.requestEncrypt(user.password);
    }

    if (user.coi.reg_no && user.coi.reg_no !== "") {
      user.coi.reg_no = this.requestEncrypt(user.coi.reg_no);
    }

    if (user.coi.personal_no && user.coi.personal_no !== "") {
      user.coi.personal_no = this.requestEncrypt(user.coi.personal_no);
    }
  }

  public post<T>(
    url: string,
    options: RequestOptions,
    data: any,
    T,
    fallback?: any
  ): Observable<T> {
    if (!(this.excludeUrls.indexOf(url) > -1)) {
      this.bIsRequesting = true;
    }
    let body: any = this.base64Service.encode(JSON.stringify(data));
    data = null;
    if (this.enc_pad || this.sessionService.SessionCryptKey) {
      body = AES.encrypt(body, this.makePassphrase());
      body = btoa(atob(body.toString()).replace("Salted__", ""));
    }

    options.headers.set("Authorization", this.sessionService.getToken());
    options.headers.set("Content-Type", "application/qsremit-encoded-form");
    options.headers.set("Accept", "application/qsremit-encoded-form");
    if (this.enc_pad) {
      options.headers.set("x-qs-pad", this.enc_pad);
    }
    const request = this.http
      .post(url, "", { body: body, headers: options.headers })
      .map((response) => {
        let payload;
        const enc_pad = response.headers.get("x-qs-pad");
        if (enc_pad) {
          this.enc_pad = enc_pad;
          this.sessionService.SessionCryptKey = enc_pad;
          payload = JSON.parse(
            this.base64Service.decode(
              this.cryptoService.aesDecrypt(
                response.text(),
                this.makePassphrase()
              )
            )
          );
        } else {
          payload = JSON.parse(this.base64Service.decode(response.text()));
        }
        if (response.status > 199 && response.status < 300) {
          if (response.headers.get("Authorization")) {
            this.sessionService.setToken(response.headers.get("Authorization"));
          }
          if (response.headers.get("Set-Cookie")) {
            this.sessionService.setSession(response.headers.get("Set-Cookie"));
          }
          if (response.status === 226) {
            this.showDuplicateAlert(payload.message);
          }
        }
        return <T>Object.assign(new T(), payload);
      })
      .catch(this._errorHandle);
    return Observable.from(request)
      .do(() => {
        this.bIsRequesting = true;
      })
      .delay(this.DELAY_TIME)
      .finally(() => {
        this.bIsRequesting = false;
      });
  }

  public get<T>(
    url: string,
    options: RequestOptions,
    T,
    fallback?: any
  ): Observable<T> {
    options.headers.set("Authorization", this.sessionService.getToken());
    options.headers.set("Content-Type", "application/qsremit-encoded-form");
    options.headers.set("Accept", "application/qsremit-encoded-form");
    this.bIsRequesting = true;
    const request = this.http
      .get(url, { headers: options.headers })
      .map((response) => {
        const enc_pad = response.headers.get("x-qs-pad");
        if (enc_pad) {
          this.enc_pad = enc_pad;
          this.sessionService.SessionCryptKey = enc_pad;
          return <T>(
            Object.assign(
              new T(),
              JSON.parse(
                this.base64Service.decode(
                  this.cryptoService.aesDecrypt(
                    response.text(),
                    this.makePassphrase()
                  )
                )
              )
            )
          );
        } else {
          return <T>(
            Object.assign(
              new T(),
              JSON.parse(this.base64Service.decode(response.text()))
            )
          );
        }
      })
      .catch(this._errorHandle);
    return Observable.from(request)
      .do(() => {
        this.bIsRequesting = true;
      })
      .delay(this.DELAY_TIME)
      .finally(() => {
        this.bIsRequesting = false;
      });
  }

  _errorHandle(response: Response) {
    if (response.status === 401) {
      delete this.enc_pad;
    }
    return Observable.throw(response);
  }

  private showDuplicateAlert(ip: string) {
    let message = "This user is currently connected from " + ip;
    message = message + "\nPrevious connection will be logged out instantly.";
    alert(message);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/service/request.service.ts